import { ReactElement, ReactNode } from 'react';

// Styles.
import styles from '../Header.module.scss';

interface IPopupMenuProps {
  children: ReactNode;
  isActive: boolean;
  rightAligned?: boolean;
  onClose: () => void;
}

export const PopupMenu = (props: IPopupMenuProps): ReactElement => {
  return props.isActive ? (
    <div className={props.rightAligned ? styles.navMenuRight : styles.navMenu}>
      <div
        onClick={() => {
          props.onClose();
        }}
      />
      <div>{props.children}</div>
    </div>
  ) : (
    <></>
  );
};
